export default "__VITE_ASSET__FJnJ7QU9__"